/** POSTrack brand images (PNG). Mark = P icon; full = horizontal wordmark; login = stacked mark + wordmark. */
export const BRAND_LOGO_MARK_SRC = '/assets/images/postrack-logo-mark.png';
export const BRAND_LOGO_FULL_SRC = '/assets/images/postrack-logo-full.png';
export const BRAND_LOGO_LOGIN_SRC = '/assets/images/pos_track_logo.png';
